
(function () {
  function renderSpecsTables(root = document) {
    root.querySelectorAll('[data-product-specs]').forEach((container) => {
      if (container.dataset.specsInitialized === 'true') return;

      const source = container.querySelector('.product-specs-table__data');
      const output = container.querySelector('.product-specs-table__output');

      if (!source || !output) return;

      let rawText;

      try {
        rawText = JSON.parse(source.textContent);
      } catch (error) {
        console.error('Unable to parse product specs:', error);
        return;
      }

      if (typeof rawText !== 'string' || !rawText.trim()) return;

      // Convert Windows/Mac line endings into standard newlines.
      const normalized = rawText.replace(/\r\n?/g, '\n').trim();

      // Each line is a row; each tab separates columns.
      const rows = normalized
        .split('\n')
        .filter((row) => row.trim())
        .map((row) => row.split('\t').map((cell) => cell.trim()));

      if (!rows.length) return;

      const table = document.createElement('table');
      table.className = 'specs-table';

      const tbody = document.createElement('tbody');

      rows.forEach((row) => {
        const tr = document.createElement('tr');

        row.forEach((value, index) => {
          const cell = document.createElement(index === 0 ? 'th' : 'td');

          cell.textContent = value;

          if (index === 0) {
            cell.setAttribute('scope', 'row');
          }

          tr.appendChild(cell);
        });

        tbody.appendChild(tr);
      });

      table.appendChild(tbody);
      output.replaceChildren(table);

      container.dataset.specsInitialized = 'true';
    });
  }

  function initialize() {
    renderSpecsTables();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Support sections reloaded in Shopify's Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    renderSpecsTables(event.target);
  });
})();
